import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Medallion } from './Medallion';
export function GuaranteeSection() {
  return <section className="defer-paint w-full bg-zinc-900 py-12 sm:py-14" aria-labelledby="guarantee-heading" data-id="element-87" data-mp="4vs0dxwxedqv">
      <div className="mx-auto max-w-3xl px-6 text-center" data-id="element-88" data-mp="9t1lx2h7259f">
        <Medallion icon={ShieldCheckIcon} data-id="element-89" data-mp="etpnuj6yo6if" />

        <p className="mt-6 font-sans text-[11px] font-semibold uppercase tracking-[0.22em] text-yellow-500" data-id="element-90" data-mp="euqxcj8bwky1">Garanzia di 7 giorni</p>
        <h2 id="guarantee-heading" className="mx-auto mt-4 max-w-xl font-serif text-[1.9rem] font-bold leading-[1.12] text-stone-100 sm:text-4xl" data-id="element-91" data-mp="ntvx1svmmkbs">
          100% protetto
        </h2>

        <p className="mx-auto mt-6 max-w-prose font-sans text-base leading-relaxed text-stone-400" data-id="element-92" data-mp="sn6yfeho68wb">
          Accedi al sistema completo e verifica di aver ricevuto i 6 volumi e i
          5 bonus dettagliati in questa pagina.
        </p>
        <p className="mx-auto mt-4 max-w-prose font-sans text-base leading-relaxed text-stone-400" data-id="element-93" data-mp="17hbnxhgzct0j">
          Se qualche file è incompleto, presenta problemi di accesso o il
          contenuto non corrisponde alla descrizione di questa offerta,
          scrivici entro 7 giorni. Lo controlleremo e, se non riusciamo a
          risolvere il problema, ti rimborseremo il{' '}
          <span className="font-medium text-stone-100" data-id="element-94" data-mp="1rsfj44kovao1">100% del tuo acquisto</span>.
        </p>
        <p className="mt-6 font-serif text-xl font-bold text-yellow-500" data-id="element-95" data-mp="2oi56qpunis7s">
          Rischio zero per te.
        </p>
      </div>
    </section>;
}